package ui.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import ui.components.Navbar
import ui.components.Footer as SiteFooter

@Composable
fun NewsScreen(
    onBack: () -> Unit,
    onNavigateToTerms: () -> Unit = {},
    onNavigateToPrivacy: () -> Unit = {}
) {
    Div(attrs = { classes("min-h-screen", "bg-gray-50") }) {
        Navbar(onNavigateHome = onBack)

        Section(attrs = { classes("pt-40", "pb-20") }) {
            Div(attrs = { classes("max-w-7xl", "mx-auto", "px-6", "text-center") }) {
                H1(attrs = { classes("text-4xl", "md:text-6xl", "font-bold", "text-gray-900", "mb-6") }) {
                    Text("Novedades")
                }
                P(attrs = { classes("text-xl", "text-gray-600") }) {
                    Text("Mantente al día con las últimas actualizaciones de Dr. Recipe.")
                }
            }
        }
        
        Div(attrs = { classes("max-w-4xl", "mx-auto", "px-6", "py-20", "text-center") }) {
            Img(src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24' fill='none' stroke='%2380CBC4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'%3E%3C/path%3E%3Cline x1='12' y1='9' x2='12' y2='13'%3E%3C/line%3E%3Cline x1='12' y1='17' x2='12.01' y2='17'%3E%3C/line%3E%3C/svg%3E", attrs = { classes("mx-auto", "mb-8") })
            H2(attrs = { classes("text-2xl", "font-bold", "text-gray-900", "mb-4") }) {
                Text("Sección en Construcción")
            }
            P(attrs = { classes("text-gray-600") }) {
                Text("Estamos preparando contenido increíble para ti. Vuelve pronto.")
            }
        }

        SiteFooter(
            onNavigateToTerms = onNavigateToTerms,
            onNavigateToPrivacy = onNavigateToPrivacy
        )
    }
}
